import React, { memo } from 'react'
import { CircleInformationMajor } from '@shopify/polaris-icons'
import tw from 'twin.macro'
import { InfoContainer } from 'src/components/shared/InfoContainer'
import { getDeactivationBannerVariant } from 'src/utils/collectData'
import { addS } from 'src/utils/baseUtils'

interface Props {
  deadlineDays: number | null
}

const getBannerCopy = (deadlineDays: number): string => {
  if (deadlineDays > 0) {
    return `Your profile will be deactivated in ${deadlineDays} ${addS(
      deadlineDays,
      'day',
    )} if these aren't renewed.`
  }

  if (deadlineDays === 0) {
    return "Your profile will be deactivated today if these aren't renewed."
  }

  return 'Your profile will be activated after you update your documents.'
}

const DeactivationBannerComponent = ({ deadlineDays }: Props) => {
  const variant = getDeactivationBannerVariant(deadlineDays)

  if (variant === null || deadlineDays === null) {
    return null
  }

  return (
    <InfoContainer
      color={variant === 'amber' ? 'orange' : 'error'}
      className={tw`py-3 px-4`}
      icon={
        <CircleInformationMajor
          width={20}
          height={20}
          css={variant === 'amber' ? tw`fill-warning-500` : tw`fill-critical-500`}
        />
      }
    >
      {getBannerCopy(deadlineDays)}
    </InfoContainer>
  )
}

export const DeactivationBanner = memo(DeactivationBannerComponent)
